import { Icon } from '@bitcine/cinesend-theme/dist'

const Lock = () => <Icon icon='lock' className='text-sm text-gray-400 px-1' />

const Refresh = () => <Icon icon='refresh' className='animate-spin-slow text-xs text-gray-400' />

const AnimatedRefresh = () => <Icon icon='refresh' className='animate-spin me-1' />

export { Lock, Refresh, AnimatedRefresh }
